import React from 'react'

import './ShareButton.scss'
import { useTranslation } from 'react-i18next'
import shareIconAndroid from '@assets/images/icons/share/share-android.png'
import shareIconIos from '@assets/images/icons/share/share-ios.png'
import { useShare } from '@hooks/useShare'
import { isApplePlatform } from '@utils/platform'

export const ShareButton = () => {
  const { t } = useTranslation('Result')
  const { handleOpenShareModal } = useShare()

  return (
    <button className="Share-Button" onClick={handleOpenShareModal}>
      {t('share')}
      <img
        className={`Share-Img ${isApplePlatform ? 'ios' : 'android'}`}
        src={isApplePlatform ? shareIconIos : shareIconAndroid}
      />
    </button>
  )
}
